
export default function Stats() {
  const stats = [
    { number: '500+', label: 'Models Created', icon: 'ri-box-3-line' },
    { number: '98%', label: 'Print Success Rate', icon: 'ri-checkbox-circle-line' },
    { number: '24h', label: 'Average Print Time', icon: 'ri-time-line' },
    { number: '50+', label: 'Happy Customers', icon: 'ri-user-smile-line' }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 bg-blue-100 rounded-full">
                <i className={`${stat.icon} text-2xl text-[#0069a5]`}></i>
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-2">{stat.number}</div>
              <div className="text-gray-600">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
